import { gql, useQuery } from "@apollo/client";
import { getFetchPolicyOptions } from "api/utils";
import { useKeycloak } from "providers/KeycloakProvider";
import { FiguresAsObject } from "@/api/types";

export const PROSPECTS_QUERY = gql`
  query GetProspects {
    contacts(contactId: "P%", contactTypeCode: "7") {
      id
      name
      contactId
      figuresAsObject {
        figures
      }
      representativeCodesString
      representativeNamesString
      externalId
      primaryAddress {
        id
        address1
        address2
        city
        zipCode
        email
        phone1
        phone2
      }
      createdDate
    }
  }
`;

interface ProspectsQuery {
  contacts: Prospect[];
}
export interface Prospect {
  id: number;
  name: string;
  contactId: string;
  representativeCodesString: string;
  representativeNamesString: string;
  externalId: string;
  primaryAddress: Address;
  figuresAsObject: FiguresAsObject;
  createdDate: string;
}
interface Address {
  address1: string;
  address2: string;
  city: string;
  zipCode: string;
  email: string;
  phone1: string;
  phone2: string;
}

export const useGetProspects = () => {
  const { linkedContact } = useKeycloak();
  const { loading, error, data, refetch } = useQuery<ProspectsQuery>(
    PROSPECTS_QUERY,
    {
      variables: { sizeLimit: null },
      ...getFetchPolicyOptions(`useGetProspects.${linkedContact}`),
    }
  );

  return {
    loading: loading,
    error: error,
    data: data?.contacts || [],
    refetch,
  };
};
